/**
 * 表单生命周期钩子名称
 */
export var LifecycleHookNames;
(function (LifecycleHookNames) {
    LifecycleHookNames["OnLoad"] = "onLoad";
    LifecycleHookNames["OnRendered"] = "onRendered";
    LifecycleHookNames["OnValidate"] = "onValidate";
    LifecycleHookNames["OnPreAction"] = "onPreAction";
    LifecycleHookNames["OnCustomAction"] = "onCustomAction";
    LifecycleHookNames["OnActionDone"] = "onActionDone";
})(LifecycleHookNames || (LifecycleHookNames = {}));
export function parseScript(script) {
    const map = {};
    const form = {
        on(type, fn) {
            if (!map[type]) {
                map[type] = [];
            }
            map[type].push(fn);
        }
    };
    try {
        eval(script)(form);
    }
    catch (error) {
        console.log('表单生命周期代码解析错误');
        throw error;
    }
    map.controller = form.controller;
    return map;
}
